import { useFlags } from "@/hooks/useFeatureFlags";
import { useHasRoles } from "@/hooks/useCapabilities";
import { ROLE } from "@/providers/AuthorizationProvider/types";

export const CCMS_MEMBER_LOOKUP_FLAG = "backoffice-ccms-member-lookup" as const;

export function useCanShowCcmsMemberLookup(): boolean {
  const flags = useFlags();
  const hasRole = useHasRoles([ROLE.GLOBAL_ADMIN, ROLE.SECTION_STAFF, ROLE.HQ_STAFF]);

  return !!flags[CCMS_MEMBER_LOOKUP_FLAG] && hasRole;
}
